import { createSlice } from "@reduxjs/toolkit";
import services from "../../api/services";

export const initialState = {
  propertyCount: 0,
  rRoomProperty: [],
  searchVal: "",
  loading: true,
  filterValues: {
    propertyCategoryFilter: [],
    roomCategoryFilter: [],
    travellerChoice: [],
    localityFilter: [],
    latlongFilter: { lat: null, long: null },
    cityId: 0,
    allowHourly: 0,
  },
};

const propertySlice = createSlice({
  name: "Property",
  initialState,
  reducers: {
    clearPropertyState: () => initialState,
    getRroomProperty: (state, { payload }) => {
      const { data, page } = payload;
      state.rRoomProperty = data;
    },
    setFilter: (state, { payload }) => {
      state.filterValues = { ...state.filterValues, ...payload };
    },
    setSearch: (state, { payload }) => {
      state.searchVal = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setPropertyCount: (state, { payload }) => {
      state.propertyCount = payload;
    },
    setCityDetail: (state, { payload }) => {
      state.cityId = payload;
    },
  },
});

export const {
  clearPropertyState,
  getRroomProperty,
  setFilter,
  setSearch,
  clearFilter,
  setLoading,
  setHasMore,
  setPropertyCount,
  setCityDetail
} = propertySlice.actions;

// Action creators are generated for each case reducer function
export const propertySeletor = (state) => state.propertys;

export default propertySlice.reducer;

export const getRroomPropertyAction = (params, page = 1) => {
  return async (dispatch, getState) => {
    const { filterValues } = getState().propertys;
    const updated = params?.replace(
      /traveller_choice=([^&]+)/,
      (_, values) => {
        const filtered = values
          .split(',')
          .filter(v => v !== '3' && v.trim() !== '')
          .join(',');
        return 'allowHourly=1';
      }
    );
    let modifyParams = filterValues?.travellerChoice?.includes(8) ? updated + '&allowHourly=1' : params
    dispatch(setLoading(true));
    try {
      const res = await services.property.searchPropertyServiceGet(modifyParams);
      if (res.status === 200) {
        const newData = res?.data?.data || [];
        if (newData.length > 0) {
          dispatch(setPropertyCount(res?.data?.count))
        }
        else {
          dispatch(setPropertyCount(0))
        }
        dispatch(getRroomProperty({ data: newData, page }));
      }
    } catch (error) {
      console.error("API Error:", error);
    }
    finally {
      dispatch(setLoading(false));
    }
  };
};
